import { Config } from "../../configurations/config";

export const LeaveManagmentAPIs = {
	//-----------------------------------Listing Screen APIS ------------------------//
	GetDefaultLeaveApplication: `${Config.server_url}${Config.api_prefix}/Leave?`,
	//-----------------------------------Create Leave Screen APIS ------------------------//
	GetMyPersonalInfoAndEmergencyContactAPI: `${Config.server_url}${Config.api_prefix}/Leave/GetMyPersonalInfoAndEmergencyContact`,
	CalculateLeaveDurationAPI: `${Config.server_url}${Config.api_prefix}/Leave/CalculateLeaveDuration`,
	GetLeaveTypesAPI: `${Config.server_url}${Config.api_prefix}/Leave/LeaveTypes`,
	CreateLeaveAPI: `${Config.server_url}${Config.api_prefix}/Leave`,
	UpdateLeaveAPI: `${Config.server_url}${Config.api_prefix}/Leave`,
	UpdateEmergencyContactAPI: `${Config.server_url}${Config.api_prefix}/Leave/UpdateEmergencyContact`,

	//------------------------ Manage Leave Screen APIS -----------------------//
	GetLeave: `${Config.server_url}${Config.api_prefix}/Leave`,
	GetLeavesQuota: `${Config.server_url}${Config.api_prefix}/Leave/AvailableLeaveQuota`,
	GetLeaveStatusTypes: `${Config.server_url}${Config.api_prefix}/Leave/GetLeaveStatusTypes`,
	GetLeavesbyPagination: `${Config.server_url}${Config.api_prefix}/Leave?`,
	DeleteLeave: `${Config.server_url}${Config.api_prefix}/Leave`,
	AddHoursInTimesheet: `${Config.server_url}${Config.api_prefix}/Leave`,

	//------------------------ Supervisor ROle -Resource Leaves Info APIS -----------------------//
	GetSupervisorsEmployeesList: `${Config.server_url}${Config.api_prefix}/Employee/GetSupervisorsEmployeesList`,
	GetResourceLeavesInfoById: `${Config.server_url}${Config.api_prefix}/Leave/GetResourceLeaveInfo`,
};
